<mat-list>
  <ng-container *ngFor="let source of knowledgeSources">
    <mat-list-item lines="3">
      <a matListItemTitle class="knowledge-source-title" (click)="clickTitle(source)">{{ source.name }}</a>

      <!-- Note: matListItemLine doesn't apply properly if these lines are in a container, so each line has a condition...-->

      <!-- Website Config Lines-->
      <div class="preview" *ngIf="source?.config?.websiteScrapeConfig" matListItemLine>
        <span>{{ getKnowledgePreview(source) }}</span>
      </div>
      <div class="last-scraped" *ngIf="source?.config?.websiteScrapeConfig" matListItemLine>
        <span>{{ 'WEBSITE_SCRAPE.LAST_SCRAPED' | translate: { lastScraped: getLastScraped(source) } }}</span>
      </div>

      <!-- Non-Website Config Lines-->
      <span class="preview" *ngIf="!source?.config?.websiteScrapeConfig?.lastScraped">{{
        getKnowledgePreview(source)
      }}</span>

      <div matListItemMeta *ngIf="canRemoveSource(source)">
        <div>
          <mat-icon class="clickable" (click)="clickRemove(source)">close</mat-icon>
        </div>
      </div>
    </mat-list-item>
    <mat-divider></mat-divider>
  </ng-container>
</mat-list>
